export default __webpack_public_path__ + "static/msh-newLogo-transparent-98287aff16804a3d567cb20f23b856de.png";